import { CellContext, type RowData } from 'src/lib/tanstack-react-table';
import { capitalize } from '@mui/material/utils';
import { StyledLabel } from './common';

export const TextCapitalizeCell = <TType extends RowData, TValue>({ getValue }: CellContext<TType, TValue>) => {
  const cellValue = capitalize(getValue<string>() || '');

  return <StyledLabel>{cellValue}</StyledLabel>;
};
